<script setup lang="ts">
export interface TableData {
  title: string;
  headers: string[];
  rows: (string | number)[][];
}

defineProps<{
  data: TableData;
}>();
</script>

<template>
  <div class="table-container">
    <table class="glass-table">
      <thead>
        <tr>
          <th v-for="(header, index) in data.headers" :key="index">
            <h6>{{ header }}</h6>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, rowIndex) in data.rows"
          :key="rowIndex"
          :class="rowIndex % 2 === 0 ? 'row-even' : 'row-odd'"
        >
          <td v-for="(cell, cellIndex) in row" :key="cellIndex">
            {{ cell }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.table-container {
  overflow-x: auto;
}

.glass-table {
  width: 100%;
}

.glass-table thead {
  background-color: var(--md-surface-container);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

.glass-table th {
  padding: 0.25rem 1rem;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--md-on-surface);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

.glass-table td {
  padding: 0.25rem 1rem;
  font-size: 12px;
  color: var(--md-on-surface);
}

.glass-table th,
.glass-table td {
  color: var(--md-on-surface);
}

.glass-table thead {
  background-color: var(--md-surface-container);
}

.row-even {
  background-color: var(--md-surface-container-low);
}

.row-odd {
  background-color: var(--md-surface-container-high);
}
</style>
